// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"fea798c6","453":"6b842c5b","850":"2bdd6ba3"}[chunkId] + ".chunk.js";
};